const MoldDetailSkeleton = () => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen animate-pulse">
      <div className="mx-auto max-w-7xl space-y-1">
        {/* Back button skeleton */}
        <div className="w-48 h-6 bg-gray-200 rounded"></div>

        {/* Main card */}
        <div className="bg-white rounded-lg shadow-md p-6">
          {/* Header */}
          <div className="flex justify-start gap-2 items-center mb-4">
            <div className="w-64 h-8 bg-gray-200 rounded"></div>
            <div className="w-24 h-6 bg-gray-200 rounded-full"></div>
          </div>

          <div className="flex flex-col lg:flex-row gap-6">
            {/* Left Column - Form Fields */}
            <div className="flex-grow">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="space-y-2">
                    <div className="w-32 h-4 bg-gray-200 rounded"></div>
                    <div className="w-full h-10 bg-gray-200 rounded"></div>
                  </div>
                ))}
              </div>

              {/* Shot Count Progress Bar */}
              <div className="mt-4">
                <div className="w-40 h-4 bg-gray-200 rounded mb-2"></div>
                <div className="w-full h-6 bg-gray-200 rounded"></div>
              </div>
            </div>

            {/* Right Column - Action Buttons */}
            <div className="lg:w-64 flex flex-col gap-3">
              <div className="w-full h-10 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        {/* Tabs Card */}
        <div className="bg-white rounded-lg shadow-md">
          {/* Tab Buttons */}
          <div className="flex border-b">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex-1 py-3 px-4">
                <div className="w-full h-6 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>

          {/* Tab Content */}
          <div className="p-6">
            <div className="space-y-4">
              {/* Table Header */}
              <div className="w-48 h-8 bg-gray-200 rounded mb-4"></div>

              {/* Table */}
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      {[...Array(6)].map((_, i) => (
                        <th key={i} className="pb-4">
                          <div className="w-full h-4 bg-gray-200 rounded"></div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(3)].map((_, rowIndex) => (
                      <tr key={rowIndex}>
                        {[...Array(6)].map((_, colIndex) => (
                          <td key={colIndex} className="py-4">
                            <div className="w-full h-4 bg-gray-200 rounded"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoldDetailSkeleton;
